import { SelfServeNode } from "../types";
import { buildNodeLevelPropName } from "../utils/buildNodeLevelPropName";
import { setSelectedNodeToLocalStorage } from "../utils/localStorage";

import { useSelfServeContextStore } from "./SelfServeContext";
import { setSelectedNodeAndResetNodesAbove } from "./useNodeSetter";

interface MultipleNodesSetter {
  setMultipleNodes: (nodes: SelfServeNode[]) => void;
}

export const useMultipleNodesSetter = (): MultipleNodesSetter => {
  const [, setSelfServeContextStore] = useSelfServeContextStore([]);
  const setters: MultipleNodesSetter = {} as MultipleNodesSetter;

  setters.setMultipleNodes = (nodes: SelfServeNode[]) => {
    for (const node of nodes) {
      const level = node.level;
      const nodeLevelProp = buildNodeLevelPropName(level);
      const selectedNode = { [nodeLevelProp]: node };
      setSelectedNodeAndResetNodesAbove(
        level,
        setSelfServeContextStore,
        selectedNode
      );
      setSelectedNodeToLocalStorage(level, node.id);
    }
  };

  return setters;
};
